import React, { useState } from 'react';
import { Info } from 'lucide-react';
interface AuthorCardProps {
  name: string;
  title: string;
  imageUrl: string;
  lastUpdated: string;
}
export function AuthorCard({
  name,
  title,
  imageUrl,
  lastUpdated
}: AuthorCardProps) {
  const [showProfile, setShowProfile] = useState(false);
  return <div className="relative inline-block" data-id="element-44">
      <div className="flex items-center gap-3" data-id="element-45">
        <img src={imageUrl} alt={name} className="w-12 h-12 rounded-full object-cover" data-id="element-46" />
        <div className="text-left" data-id="element-47">
          <div className="flex items-center gap-2" data-id="element-48">
            <p className="font-semibold text-gray-900" data-id="element-49">{name}</p>
            <img src="https://assets.checkoutchamp.com/9304c7c0-563a-11ee-8f2e-0115567b5690/1707336831448_greentick.png" alt="Verified" className="w-5 h-5" data-id="element-50" />
            <button onClick={() => setShowProfile(!showProfile)} onMouseEnter={() => setShowProfile(true)} onMouseLeave={() => setShowProfile(false)} className="w-5 h-5 rounded-full bg-purple-600 hover:bg-purple-700 flex items-center justify-center transition-colors group relative" aria-label="See profile" data-id="element-51">
              <Info className="w-3 h-3 text-white" data-id="element-52" />
            </button>
          </div>
          <p className="text-sm text-gray-600" data-id="element-53">{title}</p>
          <p className="text-xs text-gray-500" data-id="element-54">{lastUpdated}</p>
        </div>
      </div>

      {/* Profile Popup */}
      {showProfile && <div className="absolute top-full left-0 mt-2 w-80 bg-white rounded-xl shadow-2xl border border-gray-200 p-6 z-50 animate-fade-in" onMouseEnter={() => setShowProfile(true)} onMouseLeave={() => setShowProfile(false)} data-id="element-55">
          <div className="flex items-start gap-4 mb-4" data-id="element-56">
            <img src={imageUrl} alt={name} className="w-16 h-16 rounded-full object-cover" data-id="element-57" />
            <div className="flex-1" data-id="element-58">
              <div className="flex items-center gap-2 mb-1" data-id="element-59">
                <h3 className="font-bold text-gray-900" data-id="element-60">{name}</h3>
                <img src="https://assets.checkoutchamp.com/9304c7c0-563a-11ee-8f2e-0115567b5690/1707336831448_greentick.png" alt="Verified" className="w-5 h-5" data-id="element-61" />
              </div>
              <p className="text-sm text-gray-600 mb-2" data-id="element-62">{title}</p>
              <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-63">
                <img src="https://assets.checkoutchamp.com/9304c7c0-563a-11ee-8f2e-0115567b5690/1707336831448_greentick.png" alt="Verified" className="w-4 h-4" data-id="element-64" />
                <span data-id="element-65">Verified Expert</span>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-4 space-y-3" data-id="element-66">
            <div data-id="element-67">
              <h4 className="text-sm font-semibold text-gray-900 mb-1" data-id="element-68">
                Credentials
              </h4>
              <p className="text-sm text-gray-600" data-id="element-69">
                Ph.D. in Sleep Medicine, Mayo Clinic
              </p>
            </div>
            <div data-id="element-70">
              <h4 className="text-sm font-semibold text-gray-900 mb-1" data-id="element-71">
                Specialization
              </h4>
              <p className="text-sm text-gray-600" data-id="element-72">
                Sleep disorders, circadian rhythm research, and evidence-based
                sleep interventions
              </p>
            </div>
            <div data-id="element-73">
              <h4 className="text-sm font-semibold text-gray-900 mb-1" data-id="element-74">
                Publications
              </h4>
              <p className="text-sm text-gray-600" data-id="element-75">
                50+ peer-reviewed articles on sleep science
              </p>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-76">
            <p className="text-xs text-gray-500" data-id="element-77">{lastUpdated}</p>
          </div>
        </div>}
    </div>;
}